<template>
  <div>
    <Head title="Themen"/>
    <h1 class="h1">{{ __('categories.menu') }}</h1>

    <div class="card mb-5 lg:flex items-center gap-5">
      <div class="min-h-[42px] mb-4">
        <label for="isRandomOrder" class="mt-1 inline-flex relative cursor-pointer mb-2 lg:mb-0">
          <div>
            <input v-model="isRandomOrder" type="checkbox" id="isRandomOrder" class="sr-only peer">
            <div :class="toggleClass"
                 class=" w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
          </div>
          <span class="ml-3 text-sm font-medium text-gray-900">Zufällige Reihenfolge?</span>
        </label>
        <p class="text-sm italic text-gray-500">Mit der zufälligen Reihenfolge werden die Fragen gemischt. Ansonsten
          erscheinen sie in chronologischer Reihenfolge.</p>
      </div>

      <div class="min-h-[42px] mb-4">
        <label for="isLimit" class="mt-1 inline-flex relative cursor-pointer mb-2 lg:mb-0">
          <div>
            <input v-model="isLimit" type="checkbox" id="isLimit" @change="onLimitChange" class="sr-only peer">
            <div :class="toggleLimitClass"
                 class=" w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"
            ></div>
          </div>
          <span class="ml-3 text-sm font-medium text-gray-900">Fragenanzahl limitieren?</span>
        </label>
        <p class="text-sm italic text-gray-500">Du kannst die Anzahl der Fragen außerdem beliebig limitieren.</p>
      </div>

      <label v-if="isLimit" for="isRandomOrder"
             class="inline-block lg:inline-flex relative items-center cursor-pointer mb-4">
        <text-input v-model="questionCount" type="number" placeholder="Anzahl der Fragen eingebn" class=""/>
        <!--        <span class="block lg:hidden xl:inline-block mt-2 lg:mt-0 lg:ml-2">Anzahl der Fragen</span>-->
      </label>

      <div class="min-h-[42px] mb-4">
        <label for="showOnlyNotPracticedQuestions"
               class="mt-1 inline-flex relative cursor-pointer mb-2 lg:mb-0">
          <div>
            <input v-model="showOnlyNotPracticedQuestions" @change="onNotPracticeChange" type="checkbox"
                   id="showOnlyNotPracticedQuestions"
                   class="sr-only peer">
            <div :class="togglePracticeClass"
                 class=" w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"
            ></div>
          </div>
          <span class="ml-3 text-sm font-medium text-gray-900">Nur neue Fragen üben</span>
        </label>
        <p class="text-sm italic text-gray-500">In diesem Modus werden nur Fragen ausgewählt, die du noch nicht bearbeitet hast.</p>
      </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-x-5 lg:gap-y-5">
      <category-item v-for="(category, index) in categories"
                     :key="index"
                     :params="getParams"
                     :category="category"/>
    </div>

    <div v-if="categories.length === 0">
      Derzeit stehen keine Kategorien zur Verfügung
    </div>
  </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import {Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '../../Shared/TextInput'
import CategoryItem from '../../Shared/Categories/CategoryItem.vue'

export default {
  components: {
    CategoryItem,
    Head,
    Link,
    TextInput,
  },

  layout: Layout,

  props: {
    categories: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      questionCount: 50,
      isRandomOrder: false,
      isLimit: false,
      showOnlyNotPracticedQuestions: true,
    }
  },

  methods: {
    onNotPracticeChange() {
      if (this.showOnlyNotPracticedQuestions) {
        this.isLimit = false;
      }
    },

    onLimitChange() {
      if (this.isLimit) {
        this.showOnlyNotPracticedQuestions = false;
      }
    }
  },

  computed: {
    getParams() {
      let random = (this.isRandomOrder) ? '1' : '0'
      let notPracticed = (this.showOnlyNotPracticedQuestions) ? '1' : '0'
      let limit = -1
      if (this.isLimit) {
        limit = this.questionCount
      }
      return `?count=${limit}&random=${random}&not-practiced=${notPracticed}`
    },

    toggleClass: function () {
      return (this.isRandomOrder) ? 'bg-secondary-500' : 'bg-gray-200'
    },
    toggleLimitClass: function () {
      return (this.isLimit) ? 'bg-secondary-500' : 'bg-gray-200'
    },
    togglePracticeClass: function () {
      return (this.showOnlyNotPracticedQuestions) ? 'bg-secondary-500' : 'bg-gray-200'
    },
  },
}
</script>
